module.exports = __webpack_public_path__ + "static/img/jd.0ffc17a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/jd.png
// module id = 51
// module chunks = 0